import { getConstant } from '../utils';

export const getMeteodata = getConstant('GET_METEODATA');
export const getAnalysisMeteodata = getConstant('GET_METEODATA_ANALYSIS');
export const getEffectiveMeteodata = getConstant('GET_METEODATA_EFFECTIVE');
export const getPrecipitationMeteodata = getConstant('GET_METEODATA_PRECIPITATION');